import { CheckoutStatus } from '@as-react/common-types';
import { CheckoutActionTypes } from '../../../enums/ActionEnums';
export const initDeliveryErrors = {
    COLLECT_STORE: '',
    COLLECT_HQ: '',
    HOME_DELIVERY: '',
    NEXT_DAY: '',
    NAMED_DAY: '',
    PICKUP_POINT: '',
};
export const initialState = {
    state: CheckoutStatus.UNKNOWN,
    confirmationError: undefined,
    confirmationOrder: undefined,
    confirmationIsCollectStore: false,
    newsletterPreferences: undefined,
};
export const checkoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case CheckoutActionTypes.SET_CONFIRMATION_ORDER:
            return Object.assign(Object.assign({}, state), { confirmationOrder: action.payload });
        case CheckoutActionTypes.SET_CONFIRMATION_IS_COLLECT_STORE:
            return Object.assign(Object.assign({}, state), { confirmationIsCollectStore: action.payload });
        case CheckoutActionTypes.SET_CONFIRMATION_ORDER_ERROR:
            return Object.assign(Object.assign({}, state), { confirmationError: action.payload });
        case CheckoutActionTypes.SET_NEWSLETTER_PREFERENCES:
            return Object.assign(Object.assign({}, state), { newsletterPreferences: action.payload });
        case CheckoutActionTypes.SET_HAS_REGISTRATION:
            return Object.assign(Object.assign({}, state), { hasRegistration: action.payload });
        default:
            return state;
    }
};
